import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import { useClientDetails, useSectionEditing } from './ClientDetailsFormContext'

const useStyles = makeStyles((theme) => ({
  sectionScreen: {
    backgroundColor: 'var(--theme-color-surface-d0)',
    opacity: ({ editing, sectionIsEditing }) => editing && !sectionIsEditing ? 0.4 : 1,
    transition: 'opacity 300ms ease-in-out',
    pointerEvents: ({ editing, sectionIsEditing }) => editing && !sectionIsEditing ? 'none' : 'auto'
  }
}))

function SectionScreen ({ sectionName, children, className }) {
  const { editing } = useClientDetails()
  const sectionIsEditing = useSectionEditing(sectionName)
  useEffect(() => {
    console.debug('SectionScreen', sectionName, editing, sectionIsEditing)
  }, [sectionName, editing, sectionIsEditing])
  const onClick = useCallback((e) => {
    if (!sectionIsEditing) {
      e.preventDefault()
      e.stopPropagation()
    }
  }, [sectionIsEditing])

  const classes = useStyles({ editing, sectionIsEditing })

  return (
    <section className={clsx(classes.sectionScreen, className)} onClick={onClick}>
      {children}
    </section>
  )
}

SectionScreen.propTypes = {
  sectionName: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
}

export default SectionScreen
